import l from "./td-longtail-vue-components137.js";
/* empty css                              */
import o from "./td-longtail-vue-components98.js";
var n = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t(r.InputWrapper, e._b({ scopedSlots: e._u([{ key: "default", fn: function({ id: a }) {
    return [t("select", e._b({ staticClass: "input-wrapper__input selectbox", class: r.inputOrCustomInputClass, attrs: { id: a, autocomplete: e.autocomplete, "aria-invalid": !!e.errorMessage, "aria-describedby": `${a}-error` }, on: { change: r.onInput } }, "select", r.inputFieldProps, !1), [e.hidePrompt ? e._e() : t("option", { domProps: { selected: e.promptValue === e.value, value: e.promptValue } }, [e._v(" " + e._s(e.prompt) + " ")]), e._l(r.sanitizedOptions, function(s) {
      return t("option", { key: s.value, domProps: { selected: s.value === e.value, value: s.value } }, [e._v(" " + e._s(s.label) + " ")]);
    })], 2), t("svg", { staticClass: "selectbox__icon", attrs: { xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "false", viewBox: "0 0 24 24" } }, [t("path", { attrs: { "fill-rule": "evenodd", d: "M18.55 8.72a.75.75 0 0 0-1.06-.04L12 13.75 6.51 8.68a.75.75 0 0 0-1.06.04.75.75 0 0 0 .04 1.06L12 15.8l6.51-6a.75.75 0 0 0 .04-1.07", "clip-rule": "evenodd", fill: "currentColor" } })])];
  } }]) }, "InputWrapper", r.inputWrapperProps, !1));
}, p = [], u = /* @__PURE__ */ o(
  l,
  n,
  p,
  !1,
  null,
  "dd66d779"
);
const m = u.exports;
export {
  m as default
};
